if (!customElements.get('product-service-cards')) {
  customElements.define('product-service-cards', class extends HTMLElement {
    connectedCallback() {
      if (this.onToggle) return;
      this.onToggle = (event) => {
        if (event.target.tagName !== 'DETAILS' || !event.target.open) return;
        this.querySelectorAll('details[open]').forEach((details) => {
          if (details !== event.target) details.open = false;
        });
      };
      this.addEventListener('toggle', this.onToggle, true);
    }

    disconnectedCallback() {
      this.removeEventListener('toggle', this.onToggle, true);
      this.onToggle = null;
    }
  });
}
